module.exports = __webpack_public_path__ + "assets/smart-asset-code.a8666cbc.svg";